import React, { useState, useEffect, useRef } from "react";
import "../BaseStyles.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Delete from "@mui/icons-material/Delete";
import axios from "axios";
import RestaurantTable from "../RestaurantTable";

const BuffetItem = ({ item, index }) => {
  const [selectedRestaurants, setSelectedRestaurants] = useState([]);
  const [allRestaurants, setAllRestaurants] = useState([]);
  const [currOpen, setCurrOpen] = useState(false);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchSelectedRestaurants = async () => {
      try {
        const res = await axios.get(
          "https://resto-app-user.herokuapp.com/recommendation/get-restaurants-by-recommendations/" +
            item.name
        );
        if (mounted) {
          setSelectedRestaurants(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    };
    fetchSelectedRestaurants();

    return () => {
      mounted = false;
    };
  }, [refetch]);

  useEffect(() => {
    let mounted = true;

    const fetchAllRestaurants = async () => {
      try {
        const res = await axios.get(
          `https://resto-app-user.herokuapp.com/get-all-restaurants`
        );
        if (mounted) {
          setAllRestaurants(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    };
    fetchAllRestaurants();

    return () => {
      mounted = false;
    };
  }, []);

  const updateRecommendation = async (values) => {
    const body = { restaurantID: values };
    // try {
    //   const res = await axios.post(
    //     "https://resto-app-user.herokuapp.com/recommendation/add-restaurants-to-cool-areas/" +
    //       item.name,
    //     body
    //   );
    // } catch (e) {
    //   console.log(e);
    // }
    // setRefetch((prev) => !prev);
    setCurrOpen(false);
  };

  const updateState = (e) => {
    if (e === currOpen) {
      setCurrOpen(false);
    } else {
      setCurrOpen(e);
    }
  };

  return (
    <div className="p-5  border-b border-gray-300 w-full flex flex-row content-center flex-wrap">
      <div className="w-1/12 text-gray-600 justify-center">{index}</div>
      <div className="w-4/12 text-md text-red-600">{item.name}</div>
      <div
        className="w-4/12 text-md text-indigo-500"
        onClick={() => updateState("selected")}
        style={{ cursor: "pointer" }}
      >
        {selectedRestaurants.length} restaurants
      </div>
      <div className="w-2/12 text-green-500" onClick={() => updateState("all")}>
        <AddCircleOutlineIcon />
      </div>
      <div className="w-1/12 text-gray-700">
        <Delete />
      </div>
      <div className="w-full">
        {currOpen === "selected" ? (
          <RestaurantTable
            rows={selectedRestaurants}
            model={selectedRestaurants}
            updateRecommendation={updateRecommendation}
          />
        ) : currOpen === "all" ? (
          <RestaurantTable
            rows={allRestaurants}
            model={selectedRestaurants}
            updateRecommendation={updateRecommendation}
          />
        ) : null}
      </div>
    </div>
  );
};

export default BuffetItem;
